import { render } from "./ThinWall.vue?vue&type=template&id=29b5f824&scoped=true"
import script from "./ThinWall.vue?vue&type=script&lang=js"
export * from "./ThinWall.vue?vue&type=script&lang=js"

import "./ThinWall.vue?vue&type=style&index=0&id=29b5f824&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29b5f824"]])

export default __exports__